//build command: ng build --configuration=qa
//TODO: update config to point to QA app urls/config
export const environment = {
  production: true,
  apiUrl: 'https://apiv2.dynqa.oneok.com',
  apiUrlV2: 'https://apiv2.dynqa.oneok.com',
  posthog: 'phc_luP0tlSXLuQh0qA3S7qxNH8vKW6Pn59mYpzNlM5btTq',
  strapi: {
    url: 'https://content.dynqa.oneok.com',
    accessToken:
      '4e0775952c56677d232b2db94ad964e043c974a3744308a21113c9eab96a4551b1b85c15d4d1be9a5dba1750c4e8a6ca2662bda22e601e49efb7ad4203e75c2e1e3d0d82951331259409f6677bf9cda7918c5d329abf0a222ddd9e55cc5f8381bb06e3374d3e659fa97b431753b56c1cba69991928e81b6efc7fb5b0f976a75c'
  },
  targetProcess: {
    //projectId: 18049,
    projectId: 136341,
    requestTypeId: 3,
    url: 'https://tp.dynqa.oneok.com/requests'
  },
  arcGis: {
    pipesServiceUrl:
      'https://gis.oneok.com/map/rest/services/NGGP/Natural_Gas_Gathering_and_Processing_Pipelines/MapServer',
    plantsAndCompressorsServiceUrl:
      'https://gis.oneok.com/map/rest/services/NGGP/Natural_Gas_Gathering_and_Processing_Plant_Compressor/MapServer'
  },
  //DocuSign config variable
  dsConfig: {
    AccountId: 'U2FsdGVkX19Ze+FTzOPWXsCR9b0PgHYx75jm56nZVj65mZZXVaUv0DlVbrFKLMCFDfZaFlLloaCYcc67MafzDQ==',
    ApiUrl: 'https://docusign.net/restapi/v2.1/accounts',
    BasePath: 'https://na3.docusign.net/restapi',
    TemplateId: 'U2FsdGVkX191acHLpfYScMbot4cvAa1+fABHhfdqVX3EXGsHSfDOsFdL1HmBTuw2AsW8Fx+xH6SlOEH1wndtpA=='
  },
  googleRecaptcha: {
    siteKey: '6LdtneIZAAAAAJNMzrhCyYlBC2WsbIh2nJcHAaJH'
  },
  secureAuthInternal: {
    authority:
      'U2FsdGVkX1+iKaluPetuqTJ/2Lnqe4+TdwQZPhzi6hUjcJc558wwwVJGfLF+eGj/q9fqoCSaAss79/B8kzU4Ix45R1qsmjQgTuPU130NPxE=',
    client_id: 'U2FsdGVkX18gOWxDf/Oj1kdyQBi1yy0yTECr8xcFG8YaiJmFh0rNg4uDPDl6InoWPoKt+a+wOIUZ6MODsL/oUw==',
    clientRoot: 'https://customer.dynqa.oneok.com/',
    redirect_uri: 'https://customer.dynqa.oneok.com/session',
    response_type: 'id_token token',
    scope: 'openid profile email'
  },
  forgotPasswordUrl: 'U2FsdGVkX1/M6MAA6NkgfPwNQUM8Qs9zOwdYyA6xzoN6EzfHKbaY9WJSdYOjSsfOYaQIV2DImpteV07asCidyw==',
  sessionTimeoutInterval: '14400', // in seconds
  auditRequestConfig: {
    requestTypes: {
      CUSTOMER_INITIATED: {
        key: 'CUSTOMER_INITIATED',
        label: 'Customer Initiated Audit',
        value: 2431064479
      },
      GENERAL_DOCUMENT: {
        key: 'GENERAL_DOCUMENT',
        label: 'General Document Request',
        value: 2431064482
      },
      BLM_AUDIT: {
        key: 'BLM_AUDIT',
        label: 'BLM Audit Request',
        value: 2431064480
      }
    }
  }
};
